/** Klick öffnet das E-Mail-Programm der Schule mit dieser Adresse. */
import React from 'react';

export function mailtoHref(value) {
  const email = String(value || '').trim();
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return null;
  return `mailto:${email}`;
}

export default function EmailLink({ email, className = '', children, ...rest }) {
  const href = mailtoHref(email);
  const label = children ?? email;
  if (!href) return <span className={className}>{label}</span>;
  return (
    <a href={href} className={`hover:underline ${className}`.trim()} {...rest}>
      {label}
    </a>
  );
}
